export default __webpack_public_path__ + "static/media/change.4c2dbb2c.svg";